import dayjs from 'dayjs';
export default function (date, language, dateOnly = false){
    if (language == "zh"){
        if (dateOnly) return dayjs(date).tz('Asia/Hong_Kong').format("YYYY年MM月DD日")
        else return dayjs(date).tz('Asia/Hong_Kong').format("YYYY年MM月DD日 HH:mm")+" (HKT)"
    } else {
        if (dateOnly) return dayjs(date).tz('Asia/Hong_Kong').format("D MMM, YYYY")
        return dayjs(date).tz('Asia/Hong_Kong').format("D MMM, YYYY HH:mm")+" (HKT)"
    }
}